<template>
  <Moveable
    ref="handler"
    class="draggable-signature"
    v-bind="moveable"
    :style="style"
    @drag="handleDrag"
    @drag-end="handleDragEnd"
  >
    <Signature
      :name="name"
      :closable="closable"
      @close="$emit('close')"
    />
  </Moveable>
</template>

<script>

import Moveable from 'vue-moveable';

import Signature from '@/febos/global/pdf/components/Signature';
import DraggableSignatureBehaviors from '@/febos/global/pdf/mixins/DraggableSignatureBehaviors';

export default {
  mixins: [DraggableSignatureBehaviors],
  components: {
    Moveable,
    Signature
  },
  props: {
    name: { type: String, required: true },
    closable: { type: Boolean, default: true }
  }
};

</script>
